// @generated - Do not edit: this file is autogenerated by:
//   //dropbox/pap/codegen
//
// Event Property Definition: https://pap.pp.dropbox.com/#/event_property/2933

import type { DashProfilingWorkType } from "./dash_profiling_work_type";

const DashProfilingWorkTypeValues: DashProfilingWorkType[] = [
    "creative",
    "engineering_product_design",
    "financial_or_strategic_advisor",
    "human_resources",
    "information_technology",
    "marketing",
    "operations",
    "sales",
    "other",
];

export function getDashProfilingWorkTypeFromString(s: string): DashProfilingWorkType | undefined {
    return DashProfilingWorkTypeValues.find(e => e === s?.toLowerCase());
}
